import { render, staticRenderFns } from "./SampleInquiryList.vue?vue&type=template&id=78c85897"
import script from "./SampleInquiryList.vue?vue&type=script&lang=js"
export * from "./SampleInquiryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports